var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    { staticClass: "bg-grey-1" },
    [
      _c("q-card-main", { staticClass: "relative-position cursor-pointer" }, [
        _c("div", { staticClass: "line-card bg-primary absolute-top" }),
        _c("div", { staticClass: "row q-my-sm" }, [
          _c(
            "div",
            {
              staticClass: "col-3",
              on: {
                click: function($event) {
                  return _vm.openCourse()
                }
              }
            },
            [
              _c("img", {
                staticClass: "training-thumb",
                attrs: {
                  src: _vm.presential.image_small
                    ? _vm.presential.image_small
                    : _vm.getPlaceholder
                }
              })
            ]
          ),
          _c(
            "div",
            {
              staticClass: "col-8",
              on: {
                click: function($event) {
                  return _vm.openCourse()
                }
              }
            },
            [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 q-title text-weight-medium text-primary"
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.presential.title) +
                        "\n                    "
                    )
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "col-12 q-mb-md" },
                  [
                    _c("q-rating", {
                      attrs: {
                        slot: "subtitle",
                        color: "amber",
                        icon: "fas fa-star",
                        max: 5,
                        readonly: ""
                      },
                      slot: "subtitle",
                      model: {
                        value: _vm.presential.stars_rating,
                        callback: function($$v) {
                          _vm.$set(_vm.presential, "stars_rating", $$v)
                        },
                        expression: "presential.stars_rating"
                      }
                    })
                  ],
                  1
                ),
                _vm.presential.tags.length > 0 &&
                _vm.current_client !== "academiacoral"
                  ? _c("div", { staticClass: "col-12" }, [
                      _c("p", { staticClass: "caption" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("tags")) +
                            "\n                        "
                        )
                      ]),
                      _c(
                        "p",
                        { staticClass: "tooltip q-mb-sm" },
                        _vm._l(_vm.presential.tags, function(tag, index) {
                          return _c("span", { key: index }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.getTag(tag))
                            ),
                            _vm.presential.tags.length - 1 > index
                              ? _c("span", [_vm._v(", ")])
                              : _vm._e()
                          ])
                        }),
                        0
                      )
                    ])
                  : _vm._e()
              ])
            ]
          ),
          _c(
            "div",
            {
              staticClass: "col-1 text-center",
              on: {
                click: function($event) {
                  return _vm.handleProgressIconClick()
                }
              }
            },
            [
              _vm.presential.user_progress <= 0
                ? _c(
                    "vc-donut",
                    {
                      attrs: { sections: _vm.getSections, size: 100, unit: "%" }
                    },
                    [
                      _c("q-icon", {
                        attrs: {
                          name: _vm.getIconProgress,
                          color: _vm.getIconColor,
                          size: "2rem"
                        }
                      })
                    ],
                    1
                  )
                : _vm.presential.presential_event_user_result_status === 1
                ? _c(
                    "vc-donut",
                    {
                      attrs: { sections: _vm.getSections, size: 100, unit: "%" }
                    },
                    [
                      _c("q-icon", {
                        attrs: {
                          name: _vm.getIconProgress,
                          color: _vm.getIconColor,
                          size: "2rem"
                        }
                      })
                    ],
                    1
                  )
                : _vm.presential.presential_event_user_result_status === 2
                ? _c(
                    "vc-donut",
                    {
                      attrs: { sections: _vm.getSections, size: 100, unit: "%" }
                    },
                    [
                      _c("q-icon", {
                        attrs: {
                          name: _vm.getIconProgress,
                          color: _vm.getIconColor,
                          size: "2rem"
                        }
                      })
                    ],
                    1
                  )
                : _vm.presential.user_progress > 0 &&
                  _vm.presential.status === 5
                ? _c(
                    "vc-donut",
                    {
                      attrs: { sections: _vm.getSections, size: 100, unit: "%" }
                    },
                    [
                      _c("q-icon", {
                        attrs: {
                          name: _vm.getIconProgress,
                          color: _vm.getIconColor,
                          size: "2rem"
                        }
                      })
                    ],
                    1
                  )
                : _c(
                    "vc-donut",
                    {
                      attrs: { sections: _vm.getSections, size: 100, unit: "%" }
                    },
                    [
                      _c(
                        "h6",
                        {
                          class: _vm.presential.is_blocked
                            ? "text-faded"
                            : "text-primary"
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.getPercentage(_vm.presential.user_progress)
                              ) +
                              "%\n                    "
                          )
                        ]
                      )
                    ]
                  )
            ],
            1
          )
        ])
      ]),
      _c("q-card-separator"),
      _c("q-card-actions", [
        _c(
          "p",
          { staticClass: "text-center fit" },
          _vm._l(_vm.actions, function(action, index) {
            return _vm.showAction(action.slug)
              ? _c(
                  "q-btn",
                  {
                    key: index,
                    attrs: {
                      flat: "",
                      icon: action.icon,
                      color: "primary",
                      label: _vm.getLabel(action.label),
                      color: _vm.getColor(action.slug)
                    },
                    on: {
                      click: function($event) {
                        return _vm.doAction(action.slug)
                      }
                    }
                  },
                  [
                    _c("q-tooltip", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t(action.tooltip)) +
                          "\n                "
                      )
                    ])
                  ],
                  1
                )
              : _vm._e()
          }),
          1
        )
      ]),
      _vm.showSubscribeButton ? _c("q-card-separator") : _vm._e(),
      _vm.showSubscribeButton
        ? _c(
            "q-card-actions",
            [
              _c("q-btn", {
                staticClass: "full-width",
                attrs: {
                  color: _vm.getSubscribeButtonColor,
                  label: _vm.$t(_vm.getSubscribeButtonLabel),
                  icon: _vm.getSubscribeButtonIcon
                },
                on: {
                  click: function($event) {
                    return _vm.showCourseInfo(_vm.presential)
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }